import { get, post, put, patch } from "../Config"

export function SearchPageDetailSetting2({ params = {}, lang }) {
  return get({ url: `/v1/admin/page-detail-setting2`, params, lang })
}
export function GetPageDetailSetting2ById({ id, lang }) {
  return get({ url: `/v1/admin/page-detail-setting2/${id}`, lang })
}
export function CreatePageDetailSetting2({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/page-detail-setting2`, params, data, lang })
}
export function UpdatePageDetailSetting2({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/page-detail-setting2/${id}`, params, data, lang })
}
export function PatchPageDetailSetting2({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/page-detail-setting2/${id}`, params, data, lang })
}
export function DeletePageDetailSetting2({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/page-detail-setting2/mutiDelete`, params, data, lang })
}
